import React from "react";

function Badge({ value, tone = "violet" }) {
  if (!value || value <= 0) return null;

  const toneMap = {
    violet: "bg-violet-600",
    amber: "bg-amber-600",
    sky: "bg-sky-600",
    rose: "bg-rose-600",
    slate: "bg-slate-600",
    emerald: "bg-emerald-600",
  };

  return (
    <span
      className={`inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-bold leading-none text-white ${
        toneMap[tone] || toneMap.violet
      }`}
    >
      {value}
    </span>
  );
}

export default function MessagingTabs({ items = [], activeId, onChange }) {
  return (
    <nav className="grid grid-cols-3 gap-2">
      {items.map((item) => {
        const Icon = item.icon;
        const active = activeId === item.id;

        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange(item.id)}
            className={[
              "relative inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl px-3 text-sm font-bold transition",
              active
                ? "bg-violet-600 text-white shadow-lg shadow-violet-200 dark:shadow-black/20"
                : "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800",
            ].join(" ")}
            title={item.title}
          >
            <Icon className="text-sm" />
            <span>{item.title}</span>
            <Badge value={item.badge} tone={item.badgeTone} />
          </button>
        );
      })}
    </nav>
  );
}